import { render } from "./DutyInspect.vue?vue&type=template&id=61e6e51c"
import script from "./DutyInspect.vue?vue&type=script&lang=js"
export * from "./DutyInspect.vue?vue&type=script&lang=js"

import "./DutyInspect.vue?vue&type=style&index=0&id=61e6e51c&lang=less"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__